import { TLocale } from '@aviv-estimation-funnel/shells/src/app/helpers/i18n';
import { default as icons } from '@mfe-presentation/assets/svg/portals/common/sprite.svg';
import { default as frenchIcons } from '@mfe-presentation/assets/svg/portals/french/sprite.svg';

export const loadUserCentricsScript = (language: TLocale) => {
    const script = document.createElement('script');
    script.id = 'usercentrics-cmp';
    script.src = 'https://app.usercentrics.eu/browser-ui/latest/loader.js';
    script.dataset.settingsId = 'Bse70w_yBEj_bC';
    script.dataset.tcfEnabled = '';
    script.dataset.language = language;
    script.defer = true;
    document.head.appendChild(script);
};

export const preloadSvgSprite = (folder: 'french' | 'common' = 'common') => {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = folder === 'french' ? frenchIcons : icons;
    document.head.appendChild(link);
};
